import { useContext } from 'react';
import { vehicleContext } from '../components/VehicleProvider';
import type { IconNamesType } from '../types';

const useIconFromRowName = (rowName: string): IconNamesType => {
  const { market } = useContext(vehicleContext);
  const icon = market === 'cauc' ? 'charge-level' : 'vehicle-signal';

  switch (rowName) {
    case 'interior':
      return 'test-drive';
    case 'exterior':
      return 'used-car-search';
    case 'engine':
      return 'engine';
    case 'roadTest':
      return 'top-speed';
    case 'tires':
      return 'quattro';
    case 'brakes':
      return 'brake-pad';
    case 'electrical':
    case 'driverAssist':
      return icon;
    case 'charging':
      return 'battery-charge';
    case 'transmission':
      return 'transmission';
    default:
      return 'test-drive';
  }
};

export default useIconFromRowName;
